export enum GtmEventName {
    StartCalculation = 'start_calculation',
    ProposalCalculated = 'proposal_calculated',
    AddToCart = 'add_to_cart',
    Purchase = 'purchase',
}
